var map = {
	"./10-box.png": "xStk",
	"./15-box.png": "e/TU",
	"./20-box.png": "bKDX",
	"./25-box.png": "QXmk",
	"./3-box.png": "nSPJ",
	"./30-box.png": "c5cO",
	"./5-box.png": "3guH",
	"./draw-box.png": "aHHG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JaU+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\-box\.png$
// module id = JaU+
// module chunks = 0